module.exports = __webpack_public_path__ + "img/feature-1.5703e2ec.png";